export default __webpack_public_path__ + "static/media/demo3.3bc44b44.png";